import React from "react";
import "./StarryBackground.css";

const StarryBackground: React.FC = () => {
  return <div className="starry-bg" aria-hidden="true" />;
};

export default StarryBackground;
